import { Box } from "@mui/material";
import { FindingStatusIndicator } from "../FindingStatusIndicator";
import type { FindingRow, ActionContext } from "~/components/FindingsTable";
import { useFindingActions } from "~/components/FindingsTable";

type FindingStatusIndicatorCellProps = {
  row: FindingRow;
  actionContext: ActionContext;
};

export function FindingStatusIndicatorCell({
  row,
  actionContext,
}: FindingStatusIndicatorCellProps) {
  const callbacks = useFindingActions({
    finding: row,
    ...actionContext,
  });

  if (!row.states) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <FindingStatusIndicator
        findingName={row.title ?? undefined}
        states={row.states}
        {...callbacks}
      />
    </Box>
  );
}
